import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  @Input() loginForm: any;

  @Output() commit = new EventEmitter();

  constructor(private route:ActivatedRoute, public router:Router) { }

  ngOnInit(): void { }

  comminEvent(){
    this.commit.emit();
  }
}
